export const environment = {
  production: true,
  url: "https://myposconnect.ovh/myposconnect-api/",
  urlWSS: "https://myposconnect.ovh"
}
